import { render } from "./MyList.vue?vue&type=template&id=098a5979&ts=true"
import script from "./MyList.vue?vue&type=script&lang=ts"
export * from "./MyList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\JSD\\03. 사이트\\JSD_SITE\\clientapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__